<template>
  <div class="notifications">
    <transition-group
      name="notification"
      tag="div"
    >
      <div
        v-for="notification in notifications"
        :class="notificationClass(notification)"
        :key="notification.uuid"
        class="notification"
      >
        {{ notification.message }}
        <button
          v-if="notification.isRemoveable"
          class="notification__close"
          @click="removeNotification(notification)"
        >
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { mapActions, mapState } from 'vuex'
import {
  NOTIFICATION_STATE_OPENING,
  NOTIFICATION_STATE_SHOWING,
  NOTIFICATION_STATE_CLOSING
} from 'store/modules/notifications/types'

export default {
  name: 'Notifications',
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState({
      notifications: state => state.notifications.notifications
    }),
    isOpening () { return notification => notification.state === NOTIFICATION_STATE_OPENING },
    isShowing () { return notification => notification.state === NOTIFICATION_STATE_SHOWING },
    isClosing () { return notification => notification.state === NOTIFICATION_STATE_CLOSING },
    notificationClass () {
      return notification => {
        const typeModifier = notification.type
          .toLowerCase()
          .replace('notification_type_', '')
        return {
          [`notification--${typeModifier}`]: true
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'removeNotification'
    ])
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'
.notifications
  @include z-index('overlay')
  left: 0
  position: fixed
  right: 0
  top: 0
  z-index: 1100

.notification
  background: $color-white
  border-radius: rem-calc(3)
  box-shadow: $shadow-1dp
  left: rem-calc($grid-gutter-width-half)
  margin: 0 auto
  max-width: rem-calc(770)
  min-height: rem-calc(60)
  opacity: 1
  padding: rem-calc(15 20)
  position: fixed
  right: rem-calc($grid-gutter-width-half)
  text-align: center
  top: rem-calc(97)
  transition: all 300ms ease-out
  transform: translate3d(0, 0%, 0)

.notification-enter,
.notification-leave-to
  transform: translate3d(0, -100%, 0)
  opacity: 0

.notification--success
  background: $color-success
  color: $color-white

.notification--warning
  background: $color-warning
  color: $color-white

.notification--error
  background: $color-error
  color: $color-white

.notification__close
  position: absolute
  right: rem-calc(10)
  top: rem-calc(8)
  color: $color-white
  line-height: 1
  opacity: .6

  &:hover,
  &:focus
    opacity: 1
    outline: 0 none
</style>



// WEBPACK FOOTER //
// src/components/app/Notifications.vue